import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../../utils/colors';
import { useRandomLinkColors } from '../../utils/useRandomLinkColors';
const Navigation = () => {
  // Use our custom hook
  useRandomLinkColors();
  return <ul className="list-none space-y-4" data-id="element-496">
      <li className="flex" data-id="element-497">
        <span className="mr-2" data-id="element-498">↑</span>
        <Link to="/info" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-499">
          About
        </Link>
      </li>
      <li className="flex" data-id="element-500">
        <span className="mr-2" data-id="element-501">↑</span>
        <Link to="/photographs" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-502">
          Photographs
        </Link>
      </li>
      <li className="flex" data-id="element-503">
        <span className="mr-2" data-id="element-504">↑</span>
        <Link to="/writing" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-505">
          Writing
        </Link>
      </li>
      <li className="flex" data-id="element-506">
        <span className="mr-2" data-id="element-507">↑</span>
        <Link to="/books" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-508">
          Books
        </Link>
      </li>
      <li className="flex" data-id="element-509">
        <span className="mr-2" data-id="element-510">↑</span>
        <Link to="/workshops" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-511">
          Workshops
        </Link>
      </li>
      <li className="flex" data-id="element-512">
        <span className="mr-2" data-id="element-513">↑</span>
        <Link to="/news" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-514">
          News
        </Link>
      </li>
      <li className="flex" data-id="element-515">
        <span className="mr-2" data-id="element-516">↑</span>
        <Link to="/contact" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-517">
          Contact
        </Link>
      </li>
    </ul>;
};
export default Navigation;